export const text = {
  title: 'Garden Dashboard',
  description: 'Your garden tasks and progress at a glance',
  gardenSelectLabel: 'Garden',

  seedsTitle: 'Seeds to Sow',
  selectGardenForSeeds: 'Select a garden to view seeds',
  noPlantsInGarden: 'No plants in garden',
  addPlantsFirst: 'Add plants to your garden first.',
  today: 'Today',
  timeLabel: 'Time',
  now: 'Now',
  date: 'Date',
  season: 'Season',
  weather: 'Weather',
  weatherLoading: 'Loading',
  weatherUnavailable: 'Unavailable',
  wind: 'Wind',
  humidity: 'Humidity',
  seedsProgress: (sown: number, total: number) =>
    `${sown} of ${total} plant${total !== 1 ? 's' : ''} sown`,
  seedsCount: (count: number) => `${count} seeds`,
  sowTimingUnset: 'No sow timing',
  sowDueNow: 'due now',
  sowDaysAway: (days: number) => `${days} day${days === 1 ? '' : 's'}`,
  sowDaysAgo: (days: number) => `${days} day${days === 1 ? '' : 's'} ago`,
};
